import {reserveConflicts} from "../server";
import {momentFormat} from "@/config/common";

export default {
  data() {
    return {
      conflictTypes: {
        participants: "participants",
        meetingRooms: "meetingRooms",
        exclusiveRooms: "exclusiveRooms",
      },
      conflictInfo: {
        participants: [],
        meetingRooms: [],
        exclusiveRooms: [],
      },
      showConflictType: "",
      showConflictInfo: false,
    }
  },
  computed: {
    allConflictPm() {
      const {periodicInfo: dbPeriodicInfo} = this.cMDoc || {}
      const {startTime, endTime, insideParticipant, chosenRoom, branchVenues, periodicInfo} = this.dataSource;
      return {
        mid: this.mid,
        startTime: startTime.valueOf(),
        endTime: endTime.valueOf(),
        batchId: this.showPeriodic && this.mid && dbPeriodicInfo && dbPeriodicInfo.batchId || "",
        periodicInfo: this.showPeriodic && periodicInfo.periodicType && {
          ...periodicInfo,
          untilDate: periodicInfo.untilDate && periodicInfo.untilDate.valueOf() || null,
        } || null,
        userIds: (insideParticipant || []).map(e => e.userId),
        roomId: (chosenRoom || {}).roomId,
        exclusiveRoomIds: (branchVenues || []).map(e => e.roomId || e.id)
      }
    },
    conflictTitle() {
      switch (this.showConflictType) {
        case this.conflictTypes.participants:
          return this.sysFormTitles.insideParticipant
        case this.conflictTypes.meetingRooms:
          return this.sysFormTitles.meetingRoom
        case this.conflictTypes.exclusiveRooms:
          return this.sysFormTitles.branchVenues
        default:
          return ""
      }
    },
  },
  watch: {
    "dataSource.endTime": function (val) {
      // console.log("time changed")
      this.getReserveConflicts()
    },
    'dataSource.periodicInfo': {
      handler: function (newVal, oldVal) {
        // console.log("periodic changed")
        this.getReserveConflicts();
      },
      deep: true
    },
    "dataSource.insideParticipant": function (val) {
      this.getReserveConflicts(this.conflictTypes.participants)
    },
    "dataSource.chosenRoom": function (val) {
      this.getReserveConflicts(this.conflictTypes.meetingRooms);
    },
    "dataSource.branchVenues": function (val) {
      this.getReserveConflicts(this.conflictTypes.exclusiveRooms)
    },
  },
  methods: {
    getReserveConflicts(type) {
      // console.log(type || "all")
      if (!this.dataSource.startTime || !this.dataSource.endTime) return;
      const hasParticipants = this.allConflictPm.userIds.length;
      const hasMeetingRoom = this.allConflictPm.roomId;
      const hasExclusiveRooms = this.allConflictPm.exclusiveRoomIds.length;
      switch (type) {
        case this.conflictTypes.participants:
          if (!hasParticipants) {
            this.conflictInfo.participants = [];
            return;
          }
          break;
        case this.conflictTypes.meetingRooms:
          if (!hasMeetingRoom) {
            this.conflictInfo.meetingRooms = [];
            return;
          }
          break;
        case this.conflictTypes.exclusiveRooms:
          if (!hasExclusiveRooms) {
            this.conflictInfo.exclusiveRooms = [];
            return;
          }
          break;
        default:
          // 初始化时
          if (!hasParticipants && !hasMeetingRoom && !hasExclusiveRooms) return;
      }
      reserveConflicts[type || "queryAll"](this, {conflictPm: this.allConflictPm}).then(({searchReserveConflicts: rs = {}}) => {
        // console.log(rs)
        if (type) {
          this.conflictInfo[type] = this.formatConflictList(rs[type] || [])
        } else {
          Object.keys(this.conflictInfo).forEach(k => {
            this.conflictInfo[k] = this.formatConflictList(rs[k] || [])
          })
        }
      }).catch(err => {
        console.log(err);
      })
    },
    formatConflictList(list) {
      return list.map(ele => {
        const noticeUsers = ele.users && ele.users.slice(0, 3);
        return {
          ...ele,
          dateLabel: moment(ele.startTime).format(momentFormat.dateFormatDayCN),
          timeLabel: moment(ele.startTime).format(momentFormat.timeWithWeek)
            + ' - ' + moment(ele.endTime).format(momentFormat.timeWithWeek),
          userLabel: noticeUsers && (noticeUsers.map(e => e.name).join('、')
            + (ele.users.length > noticeUsers.length ? `等${ele.users.length}人` : "") + " 有会议"),
          roomLabel: (ele.rooms || []).map(e => e.name).join('、'),
        }
      })
    },
    handleShowConflicts(type) {
      this.showConflictType = type;
      this.showConflictInfo = true
    },
    checkConflictInfo() {
      if (this.conflictInfo.meetingRooms.length) {
        return this.sysFormTitles.meetingRoom + "与其它会议安排有冲突"
      }
      if (this.conflictInfo.exclusiveRooms.length) {
        return this.sysFormTitles.branchVenues + "与其它会议安排有冲突"
      }
    },
  },
}
